import { WoodGrainTuningSchema, WoodGrainTuningProfile, DEFAULT_WOOD_GRAIN } from '../architecture/wood_grain_profile';
import { RawVisionFrame, IntentFrame } from '../architecture/mosaic_pipeline';
import { KinematicTopologyGateTile } from '../tiles/kinematic_topology_gate_tile';
import { KalmanSmootherTile } from '../tiles/kalman_smoother_tile';
import { GestureFSMTile } from '../tiles/gesture_fsm_tile';
import { HighlanderMutexTile } from '../tiles/highlander_mutex_tile';
import { W3CEgressAdapter } from '../adapters/w3c_egress_adapter';

export class ExcalidrawOrchestrator {
  private readonly egress = new W3CEgressAdapter();
  // Store the active immutable tiles
  private highlander!: HighlanderMutexTile;
  private kinematicGate!: KinematicTopologyGateTile;
  private kalmanSmoother!: KalmanSmootherTile;
  private fsmTile!: GestureFSMTile;

  constructor(private readonly eventBus: any) {
    this.rebuildPipeline(DEFAULT_WOOD_GRAIN);
  }

  // TRUE CORRECT-BY-CONSTRUCTION CONFIGURATION
  private rebuildPipeline(cfg: WoodGrainTuningProfile): void {
    // Garbage collect old tiles. Instantiate pure, immutable replacements.
    this.highlander = new HighlanderMutexTile();
    this.kinematicGate = new KinematicTopologyGateTile();
    this.kalmanSmoother = new KalmanSmootherTile({ kalman_q: cfg.kalman_q, kalman_r: cfg.kalman_r });
    this.fsmTile = new GestureFSMTile({
      fsm_conf_high: cfg.fsm_conf_high,
      fsm_conf_low: cfg.fsm_conf_low,
      coast_timeout_ms: cfg.coast_timeout_ms
    });
  }

  // PURE COMPUTATION: Type-safe, mathematically locked sequence
  private processHotPath(rawFrame: RawVisionFrame): IntentFrame | null {
    const f1 = this.highlander.process(rawFrame);      if (!f1) return null;
    const f2 = this.kinematicGate.process(f1);         if (!f2) return null;
    const f3 = this.kalmanSmoother.process(f2);        if (!f3) return null;
    const finalFrame = this.fsmTile.process(f3);       if (!finalFrame) return null;
    return finalFrame;
  }

  public boot(): void {
    this.eventBus.subscribe('TUNING_PROFILE_CHANGED', (untrustedConfig: unknown) => {
      const parseResult = WoodGrainTuningSchema.safeParse(untrustedConfig);
      if (parseResult.success) this.rebuildPipeline(parseResult.data);
    });

    this.eventBus.subscribe('RAW_VISION_FRAME', (rawFrame: RawVisionFrame) => {
      const finalFrame = this.processHotPath(rawFrame);
      if (finalFrame !== null) {
        this.egress.dispatchToDOM(finalFrame as any);
        this.eventBus.publish('PIPELINE_FINAL_INTENT', finalFrame);
      }
    });
  }
}
